import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from 'src/app/authuntication/auth-service/login.service';
import { ConfirmLogotComponent } from '../components/logout/confirm-logot/confirm-logot.component';
import { MatDialog } from '@angular/material/dialog';
import { LaguageService } from 'src/app/laguage.service';

@Component({
  selector: 'app-small-header',
  templateUrl: './small-header.component.html',
  styleUrls: ['./small-header.component.scss']
})
export class SmallHeaderComponent implements OnInit {
  role: any;
  lang: any;
  admin: any;
  admin_content: any;
  developer: any;
  marketer: any;

  constructor(public translate: TranslateService, private _AuthService: LoginService,
    private dialogRef: MatDialog, private _lang: LaguageService) {
    this.lang = this._lang.getValue();
    this.getAdminRole();
  }

  ngOnInit(): void {
    this.getLanguage();
  }

  getLanguage() {
    let lang = localStorage.getItem('currentLang');
    const body = document.getElementsByTagName('body');
    if (lang == "ar") {
      body[0].setAttribute('dir', 'rtl');
      this.translate.use(lang);
      localStorage.setItem('currentLang', 'ar');
    } else {
      body[0].setAttribute('dir', 'ltr')
      localStorage.setItem('currentLang', 'en')
    }
  }

  useLanguage(language: string): void {
    this.translate.use(language);
  }

  changeCurrentLang(lang: string) {
    const body = document.getElementsByTagName('body');
    if (lang == "ar") {
      body[0].setAttribute('dir', 'rtl')
      this.translate.use(lang)
      localStorage.setItem('currentLang', 'ar')
      this._lang.setValue('ar')
    } else {
      this.translate.use(lang)
      body[0].setAttribute('dir', 'ltr')
      localStorage.setItem('currentLang', 'en')
      this._lang.setValue('en')
    }
  }

  getAdminRole() {
    if (this._AuthService.userData.sub.role === "super_admin") {
      this.role = true;
      this.admin_content = true;
      this.admin = true;
      this.developer = true;
      this.marketer = true;
    }
    else if (this._AuthService.userData.sub.role === "admin_content") {
      this.admin_content = true;
      this.role = true;
      this.admin = false;
    } else if (this._AuthService.userData.sub.role === "admin") {
      this.admin_content = false;
      this.role = false;
      this.admin = true;
    } else if (this._AuthService.userData.sub.role === "developer") {
      this.role = false;
      this.admin_content = false;
      this.admin = false;
      this.developer = true
    } else if (this._AuthService.userData.sub.role === "marketer") {
      this.role = false;
      this.admin_content = false;
      this.admin = false;
      this.developer = false;
      this.marketer = true;
    } else {
      this.role = false;
    }
  }

  isLogout() {
    this.dialogRef.open(ConfirmLogotComponent)
  }

}